module.exports = __webpack_public_path__ + "img/planning-dark.99f7fccc.svg";